/**
 * @module
 * @description Base content module for shared content js and props.
 */

import comments from './comments';

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	comments();
};

export default init;
